import { Upload, QualityEnum } from "../../interface/Upload"
import * as UploadUtil from "../../library/UploadUtil"
import ImageView from "./ImageView"
import VideoView from "./VideoView"

type didLoadCallback = (uploadId: string, debugDescription: string) => void

interface MediaViewProps {
  upload: Upload
  onScreen: boolean
  className: string
  style?: any
  quality: QualityEnum
  isReadyCallback: didLoadCallback
}

export default function MediaView({ upload, onScreen, className, style, quality, isReadyCallback }: MediaViewProps) {

  const handleIsReady = (description: string) => {
    isReadyCallback(upload.id, `Upload ${upload.id} ${description} for ${className}`)
  }

  let isVideo = upload.mime_type.includes("video/")

  let src = ""
  if (upload.media) {
    src = UploadUtil.selectFilePath(upload, quality) ?? src
  }

  if (src === "") {
    return <div onLoad={() => handleIsReady("loaded empty media")}></div>
  }

  let commonProps = {
    src: src,
    style: style,
    className: className,
    didLoad: () => handleIsReady(isVideo ? "can play video" : "loaded image"),
    didFail: () => handleIsReady("image failed")
  }

  if (isVideo) {
    return <VideoView
      play={onScreen}
      poster={upload.media?.thumbnail}
      {...commonProps} />
  }

  return <ImageView {...commonProps} />
}